import { render } from "./InstitutionsSearchBlock.vue?vue&type=template&id=0171dd36&lang=pug"
import script from "./InstitutionsSearchBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./InstitutionsSearchBlock.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__